import { startVisualiser } from './app.js';
import { setStatus } from './ui/controls.js';

try {
  await startVisualiser({ characterUrl: '/models/dancer.glb' });
} catch (error) {
  console.error('Failed to start the visualiser:', error);
  setStatus('Failed to start — this browser may not support WebGPU or WebGL2.');
}
